import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section, Title } from "@/components/UI";
import { useRefsContext } from "@/contexts/ref";
import { useI18n } from "@/shared/hooks";
import { getFeaturesEnabled } from "@/utils";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
export const geoRiskTestId = "cdp-georisk";
export const GeoRisk = () => {
    const { geoRisksRef } = useRefsContext();
    const { georisk } = getFeaturesEnabled();
    const { t } = useI18n();
    if (!georisk)
        return null;
    const onPress = () => {
        if (typeof window === "undefined")
            return;
        window.open("https://www.georisques.gouv.fr", "_blank", "noopener");
    };
    return (_jsxs(Section, { ref: geoRisksRef, testId: geoRiskTestId, children: [_jsx(Title, { title: t("georisks.title"), testId: `${geoRiskTestId}-title`, variant: "section" }), _jsx(Box, { as: "p", margin: "spacing.none", children: t("georisks.text") }), _jsx(Button, { variant: "secondary", marginTop: "spacing.16", testId: `${geoRiskTestId}-button`, isFullWidth: {
                    "breakpoint.base": true,
                    "breakpoint.sm": false,
                }, onPress: onPress, children: t("georisks.button") })] }));
};
